/**
 * Nothing typed is lost when the user moves on (owner's bug report, 2026-11-04: a mechanic's request and findings
 * were lost on a phone). A form with changes registers a guard here. Before the program moves to another screen it
 * asks every guard: a guard saves what can be saved by itself and answers with what cannot be saved (an invalid or
 * missing value); then the program asks in its own dialog whether to leave without it.
 */
export interface LeaveCheck {
  /** Labels of changed values that cannot be saved (red in the form). */
  blocked: string[];
}

type Guard = () => LeaveCheck;
const guards = new Set<Guard>();

export function registerLeaveGuard(g: Guard): () => void {
  guards.add(g);
  return () => {
    guards.delete(g);
  };
}

/** Asks every guard (each starts saving what it can); returns what would be lost. */
export function checkLeave(): string[] {
  const out: string[] = [];
  for (const g of guards) out.push(...g().blocked);
  return [...new Set(out)];
}
